export default "__VITE_ASSET__4$Snzgpk__";